<template lang="pug">
  .b2b-page-newuserentities
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('users.createuser.entitiesuser.title', { username: this.newUserSession.username } ) }}
          ods-col(:span='16')
            ods-row(type='flex', justify='end')
              ods-tooltip(:content='$t("user_detail.add_user_entity_tooltip")', placement='bottom')
                ods-button(
                  icon='ods-icon-plus',
                  type='primary'
                  size='small',
                  circle,
                  @click.native='isShowDialogAddUserEntity = true')
                  | {{ $t('user_detail.add_user_entity') }}
      ods-table(
            :data='userEntities',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterUserEntity',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='projectName',
              :label='$t("user_detail.user_entity_table.project_name")',
              :show-overflow-tooltip='true',
              v-if='!(activeUser.data.projects && activeUser.data.projects.length === 1)',
              sortable='')
            ods-table-column(
              prop='partyTaxIdentificationNumber',
              :label='$t("user_detail.user_entity_table.party_tax_identification_number")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='centreCode',
              :label='$t("user_detail.user_entity_table.centre_code")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              label='',
              width='80')
              template(slot-scope='scope')
                ods-button(
                  type='neutral',
                  @click='removeUserEntity(scope.$index)')
                  ods-icon(name='close', size='16')
    ods-row.form-actions
      ods-col(:span='24')
        ods-button(
          type='primary',
          size='large'
          @click='goPermissionsUser()')
          | {{ $t('buttons.btnNext') }}

    //- Dialog Añadir Entidades de Usuario
    ods-dialog(
      ref='dialogAddUserEntity',
      :title='$t("user_detail.dialog_add_user_entity.title")',
      :visible.sync='isShowDialogAddUserEntity',
      @close='handleCloseDialogUserEntity',
      width='30%')

      ods-form(
        ref='formDialogAddUserEntity',
        :model='formDialogAddUserEntity',
        :rules='rulesAddEntity'
        label-position='top')

        ods-form-item(
          v-show='!(activeUser.data.projects && activeUser.data.projects.length === 1)',
          :label='$t("user_detail.dialog_add_user_entity.project_name")',
          prop='projectId')
          ods-select(
            v-model='formDialogAddUserEntity.projectId',
            filterable,
            @change='changeProject()')
            ods-option(
              v-for='option in optionsUserEntityProject',
              :key='option.id',
              :label='option.name',
              :value='option.id')

        ods-form-item(
          :label='$t("user_detail.dialog_add_user_entity.party_tax_identification_number")',
          prop='partyId')
          ods-select(
            v-model='formDialogAddUserEntity.partyId',
            filterable,
            :filter-method='filterParties',
            :disabled='!showPartyAddEntity'
            @change='changeParty()')
            ods-option(
              v-for='option in optionsUserEntityParty',
              :key='option.id',
              :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
              :value='option.id')

        ods-form-item(
          :label='$t("user_detail.dialog_add_user_entity.centre_code")',
          prop='centreId')
          ods-select(
            v-model='formDialogAddUserEntity.centreId',
            filterable,
            :disabled='!showCentreAddEntity'
            @change='changeCentre()')
            ods-option(
              v-for='option in optionsUserEntityCentre',
              :key='option.id',
              :label='option.name',
              :value='option.id')

      span.dialog-footer(slot='footer')
        ods-button(
          type='primary',
          @click.native='onSubmitAddUserEntity("formDialogAddUserEntity")')
          | {{ $t('user_detail.dialog_add_user_entity.button_add') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-newuserentities',

  mixins: [Utils],

  data () {
    return {
      projectSelected: this.$t('user_detail.dialog_add_user_entity.option_all_party'),
      partySelected: this.$t('user_detail.dialog_add_user_entity.option_all_party'),
      centreSelected: this.$t('user_detail.dialog_add_user_entity.option_all_party'),
      tid: null,
      optionsUserEntityParty: [],
      optionsUserEntityCentre: [],
      centresparties: [], // Centros de las empresas

      // ENTIDADES DE USUARIO
      userEntities: [],
      currentRowUserEntity: {},
      isShowDialogAddUserEntity: false,
      formDialogAddUserEntity: {
        projectId: '',
        partyId: '',
        centreId: ''
      },
      optionsUserEntityProject: [{
        id: -1,
        name: this.$t('user_detail.dialog_add_user_entity.option_all_project')
      }],
      showPartyAddEntity: false,
      showCentreAddEntity: false
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'newUserSession',
      'urlIn']),
    rulesAddEntity () {
      const checkParty = (rule, value, callback) => {
        const projectId = this.formDialogAddUserEntity.projectId
        const partyId = this.formDialogAddUserEntity.partyId
        if (projectId !== null && projectId !== -1 && partyId === null) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      const checkCentre = (rule, value, callback) => {
        const projectId = this.formDialogAddUserEntity.projectId
        const partyId = this.formDialogAddUserEntity.partyId
        const centreId = this.formDialogAddUserEntity.centreId
        if (projectId !== null && projectId !== -1 && (partyId === null || centreId === null)) {
          callback(new Error(this.$t('msg_generics.field_required')))
        } else {
          callback()
        }
      }

      return {
        projectId: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' }
        ],
        partyId: [
          { validator: checkParty, trigger: 'blur, change' }
        ],
        centreId: [
          { validator: checkCentre, trigger: 'blur, change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getPartiesByProject',
      'getCentresByParty',
      'getCentresByPartyFenixBackend',
      'validateEntitiesUser'
    ]),

    handleCellMouseEnterUserEntity (row, column, cell, event) {
      this.currentRowUserEntity = row
    },

    // Reseteo al cerrar dialogo user entity
    handleCloseDialogUserEntity () {
      if (!(this.activeUser.data.projects && this.activeUser.data.projects.length === 1)) {
        this.$refs.formDialogAddUserEntity.resetFields()
        this.optionsUserEntityParty = []
      } else {
        this.showPartyAddEntity = true
        this.formDialogAddUserEntity.partyId = null
        this.formDialogAddUserEntity.centreId = null
      }
      this.showCentreAddEntity = false
    },

    goPermissionsUser () {
      if (this.userEntities !== null && this.userEntities.length > 0) {
        this.$emit('update', 3)
      }
    },

    // ENTIDADES DE USUARIO
    async changeProject () {
      // Reseteamos tanto la empresa como el centro
      this.formDialogAddUserEntity.partyId = null
      this.optionsUserEntityParty = []
      this.formDialogAddUserEntity.centreId = null
      this.optionsUserEntityCentre = []
      this.showPartyAddEntity = true
      // Para pintar los datos de la tabla
      for (const option of this.optionsUserEntityProject) {
        if (option.id === this.formDialogAddUserEntity.projectId) {
          this.projectSelected = option.name
        }
      }

      const partyAll = {
        id: -1,
        tradeName: this.$t('user_detail.dialog_add_user_entity.option_all_party')
      }
      // Agregamos al inicio del array
      this.optionsUserEntityParty.unshift(partyAll)
    },

    async changeParty () {
      // Reseteamos el centro
      this.formDialogAddUserEntity.centreId = null
      this.optionsUserEntityCentre = []
      if (this.formDialogAddUserEntity.partyId !== -1) {
        try {
          const data = {
            projectId: this.formDialogAddUserEntity.projectId,
            partyId: this.formDialogAddUserEntity.partyId
          }
          this.optionsUserEntityCentre = await this.getCentresByPartyFenixBackend(data)
          for (const option of this.optionsUserEntityCentre) {
            if (option.name !== this.$t('user_detail.dialog_add_user_entity.option_all_centre')) {
              option.name = option.code
            }
          }

          // Para pintar los datos de la tabla
          for (const party of this.optionsUserEntityParty) {
            if (party.id === this.formDialogAddUserEntity.partyId) {
              this.partySelected = party.tradeName
            }
          }
        } catch (error) {
          console.log('changeParty CATCH: ', error)
          this.showNotificationError(error)
        }
      }
      const centreAll = {
        id: -1,
        name: this.$t('user_detail.dialog_add_user_entity.option_all_centre')
      }
      // Agregamos al inicio del array
      this.optionsUserEntityCentre.unshift(centreAll)
      // Habilitamos campo
      this.showCentreAddEntity = true
    },

    changeCentre () {
      // Para pintar los datos de la tabla
      for (const option of this.optionsUserEntityCentre) {
        if (option.id === this.formDialogAddUserEntity.centreId) {
          this.centreSelected = option.name
        }
      }
    },
    async getPartiesResults (data) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      const datos = {
        projectId: this.formDialogAddUserEntity.projectId,
        query: {
          size: 1000,
          enabled: true,
          tradeNameOrTaxId: data,
          urlName: (this.urlIn && this.urlIn !== 'b2b' ? this.urlIn : null)
        }
      }
      try {
        if (this.formDialogAddUserEntity.projectId !== -1) {
          this.optionsUserEntityParty = await this.getPartiesByProject(datos)
        }
        const partyAll = {
          id: -1,
          tradeName: this.$t('user_detail.dialog_add_user_entity.option_all_party')
        }
        // Agregamos al inicio del array
        this.optionsUserEntityParty.unshift(partyAll)
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.showNotificationError(error)
      } finally {
        load.close()
      }
    },
    async filterParties (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getPartiesResults, 1000, data)
        // Si el valor introducido tiene más de 3 caracteres, se filtra en la propia lista obtenida anteriormente
        } else {
          // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.optionsUserEntityParty = []
        }
      } catch (error) {
        console.log('filterParties CATCH: ', error)
        this.showNotificationError(error)
      }
    },

    //* * Valida los user-entity */
    validateUserEntities (entityToAdd) {
      // Verificamos que la lista no esta vacia
      if (this.newUserSession.userentities !== null && this.newUserSession.userentities.length > 0) {
        const ALLPROJECTS = null
        const ALLPARTIES = null
        const ALLCENTRES = null
        for (const entity of this.newUserSession.userentities) {
          if (entity.projectId === ALLPROJECTS || entityToAdd.projectId === ALLPROJECTS) {
            return true
          } else if (entity.projectId === entityToAdd.projectId) {
            if (entity.partyId === ALLPARTIES || entityToAdd.partyId === ALLPARTIES) {
              return true
            } else if (entity.partyId === entityToAdd.partyId) {
              if (entity.centreId === ALLCENTRES || entityToAdd.centreId === ALLCENTRES) {
                return true
              } else if (entity.centreId === entityToAdd.centreId) {
                return true
              }
            }
          }
        }
      }
      return false
    },

    //* * Valida si el userentity ya a sido insertado previamete */
    validateUserEntitiesRepeat (entityToAdd) {
      // Verificamos que la lista no esta vacia
      if (this.newUserSession.userentities !== null && this.newUserSession.userentities.length > 0) {
        // Verificamos que no se añadido previamnete
        for (const entity of this.newUserSession.userentities) {
          if (entity.projectId === entityToAdd.projectId && entity.partyId === entityToAdd.partyId && entity.centreId === entityToAdd.centreId) {
            return true
          }
        }
      }
      return false
    },

    async onSubmitAddUserEntity (formName) {
      this.$refs[formName].validate(async valid => {
        let data = {}
        if (valid) {
          try {
            data = {
              projectName: this.projectSelected,
              partyTaxIdentificationNumber: this.partySelected,
              centreCode: this.centreSelected,
              projectId: this.formDialogAddUserEntity.projectId === -1 ? null : this.formDialogAddUserEntity.projectId,
              partyId: this.formDialogAddUserEntity.partyId === -1 ? null : this.formDialogAddUserEntity.partyId,
              centreId: this.formDialogAddUserEntity.centreId === -1 ? null : this.formDialogAddUserEntity.centreId
            }

            // -Reseteamos valores por  defecto
            if ((this.urlIn === null || this.urlIn === undefined)) {
              this.projectSelected = this.$t('user_detail.dialog_add_user_entity.option_all_party')
            }
            this.partySelected = this.$t('user_detail.dialog_add_user_entity.option_all_party')
            this.centreSelected = this.$t('user_detail.dialog_add_user_entity.option_all_party')

            // Validamos que no volvemos a insertar un user_entity ya agregado previamente
            let validate = true
            if (this.validateUserEntitiesRepeat(data)) {
              this.$notify({
                title: this.$t('user_detail.notify.add_user_entity_repeat'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
              // Si salta validacion ya no hacemos mas comprobaciones
              validate = false
            }

            if (!this.validateUserEntities(data) && validate) {
              // - Agregamos a la lista global de newUser
              this.newUserSession.userentities.push(data)
              if (this.newUserSession.userentities.length > 1) {
                await this.validateEntitiesUser(this.newUserSession)
              }
            } else {
              this.$notify({
                title: this.$t('user_detail.notify.add_user_entity_validateko'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
            }
            if (!(this.activeUser.data.projects && this.activeUser.data.projects.length === 1)) {
              this.$refs[formName].resetFields()
            }
            this.isShowDialogAddUserEntity = false
          } catch (error) {
            console.log('onSubmitAddUserEntity CATCH: ', error)
            for (let i = 0; i < this.newUserSession.userentities.length; i++) {
              if (this.newUserSession.userentities[i].projectId === data.projectId && this.newUserSession.userentities[i].partyId === data.partyId && this.newUserSession.userentities[i].centreId === data.centreId) {
                this.newUserSession.userentities.splice(i, 1)
                break
              }
            }
            this.showNotificationError(error)
          }
        } else {
          console.log('ERROR submit!!')
          return false
        }
      })
    },

    removeUserEntity (index) {
      try {
        // Removemos elemento
        this.newUserSession.userentities.splice(index, 1)
      } catch (error) {
        console.log(error)
      }
    }
  },
  async created () {
    console.log('B2bNewUserEntities', this.newUserSession)
    this.userEntities = this.newUserSession.userentities
    const load = this.$loading({
      lock: true,
      text: this.$t('user_detail.load.init_user_data')
    })
    try {
      const dataQueryService = {
        page: 0,
        size: 1000,
        enabled: true,
        sort: 'name,ASC'
      }

      const projectList = await this.getOptionsService(dataQueryService)
      if (projectList.length === 1) {
        this.optionsUserEntityProject = projectList
        this.formDialogAddUserEntity.projectId = projectList[0].id
        this.changeProject()
      } else {
        this.optionsUserEntityProject = this.optionsUserEntityProject.concat(
          projectList
        )
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.showNotificationError(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-newuserentities {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }

      .ods-button {
        float: right;
      }
      .ods-button--small.is-round {
        padding: 0px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
      .ods-table{
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 10px;
            i {
              margin-left: 0px;
            }
          }
        }
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }

  .collapse {
    margin-top: 64px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    .ods-button {
      float: right;
    }

    ::v-deep .ods-module {
      &__body {
        padding: 0px;
      }
    }
  }
}
</style>
